import * as Enumerable from 'linq';

import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Allocation, BookingStatus, DateUtility, Source } from '@jms/model';

import { APPOINTMENT_SERVICE, AppointmentsService } from '../../../common';
import { AppointmentGroup } from '../../models';
import { AllocationUtility } from '@jms/shared/module.scheduling.allocations.pro/src/helpers';

@Component({
    selector: 'appointment-list-sidebar',
    templateUrl: './appointment.list.sidebar.component.html',
    styleUrls: ['./appointment.list.sidebar.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AppointmentListSidebarComponent implements OnChanges {

  @Input() public appointments: Allocation[];
  @Input() public selectedAppointment: Allocation;
  @Input() public timezone: string;
  @Input() public timeFormat: string;
  @Input() public readonly = false;

  @Output() public delete = new EventEmitter<Allocation>();
  @Output() public edit = new EventEmitter<Allocation>();

  public groups: AppointmentGroup[] = [];
  public source: Source;

  public readonly Source = Source;
  public readonly BookingStatus = BookingStatus;

  constructor(
    @Inject(APPOINTMENT_SERVICE) private appointmentsService: AppointmentsService,
  ) {
    this.source = this.appointmentsService.source;
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.appointments || changes.timezone) {

      this.groups = Enumerable.from(this.appointments)
        .orderByDescending(allocation => {
          return DateUtility.getDateTime(allocation.startDate, this.timezone).startOf('day').toJSDate();
        })
        .groupBy(x => {
          const startDate = DateUtility.getDateTime(x.startDate, this.timezone).startOf('day').toJSDate().getTime();
          return startDate;
        })
        .select(x => {

          const item: AppointmentGroup = {
            date: new Date(x.key()),
            allocations: Enumerable.from(x.getSource()).orderBy(x => x.startDate).toArray()
          };

          return item;
        })
        .toArray();

    }
  }



  public onEdit(item: Allocation) {
    this.edit.emit(item)
  }

  public onDelete(item: Allocation) {
    this.delete.emit(item)
  }

  public canEdit(item: Allocation): boolean {
    return !this.readonly && this.appointmentsService.canEdit(item);
  }

  public canDelete(item: Allocation): boolean {
    return !this.readonly && this.appointmentsService.canDelete(item);
  }

  protected isShadow(item: Allocation): boolean {
    return AllocationUtility.isShadow(item);
  }


}
